import { get, post, put } from "@selector/shared";
import type { components } from "@selector/shared/openapi";
import { pick } from "lodash-es";

import type {
  SavedSyntenyView,
  SavedViewMetadata,
  SavedViewValidationData,
} from "../../store/slices/save-load-slice.ts";

const pickState = (state: SavedSyntenyView) => ({
  ...state,
  alignedFamily: {
    ...state.alignedFamily,
    members: (state.alignedFamily?.members ?? []).map((member) =>
      pick(member, ["featureId", "trackId"]),
    ) as components["schemas"]["FamilyMemberRequest"][],
  },
});

export async function postSavedView(metadata: SavedViewMetadata, state: SavedSyntenyView): Promise<number> {
  const { data } = await post("/view/synteny", undefined, undefined, {
    ...metadata,
    state: pickState(state),
  });
  return data;
}

export async function fetchSavedView(viewId: number) {
  return get("/view/synteny/{viewId}", { viewId });
}

export async function putSavedView(metadata: SavedViewMetadata, state: SavedSyntenyView): Promise<number> {
  return put("/view/synteny", undefined, undefined, {
    ...metadata,
    state: pickState(state),
  });
}

export async function getValidateProjectCompatibility(
  projectId: number,
  organismId: number,
): Promise<SavedViewValidationData> {
  return get("/view/isProjectCompatible/{projectId}/{organismId}", { projectId, organismId });
}
